import * as Types from '../../../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateMarketMutationVariables = Types.Exact<{
  createMarketInput: Types.CreateMarketInputGraphqlType;
}>;


export type CreateMarketMutation = { __typename?: 'Mutation', adminCreateMarket: { __typename?: 'MarketOutputGraphqlType', market: { __typename?: 'MarketGraphqlType', id: number, name: string } } };

export type AdminGetMarketsSessionQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.MarketPageQueryFilter>;
}>;


export type AdminGetMarketsSessionQuery = { __typename?: 'Query', adminMarkets: { __typename?: 'AdminMarketPageGraphqlType', totalCount: number } };

export type UpdateMarketMutationVariables = Types.Exact<{
  updateMarketInput: Types.UpdateMarketInputGraphqlType;
}>;


export type UpdateMarketMutation = { __typename?: 'Mutation', adminUpdateMarket: { __typename?: 'MarketOutputGraphqlType', market: { __typename?: 'MarketGraphqlType', additionalFee?: number | null, comment?: string | null, deliveryCost?: number | null, deliveryFeeType: Types.EProductGroupDeliveryFeeType, endedAt?: string | null, expectedSales?: number | null, expectedSettlementAt?: string | null, freeDeliveryConditionFee?: number | null, id: number, isRegionFee: boolean, isSellerAssigned: boolean, jejuIslandFee?: number | null, name: string, releaseTime?: string | null, releaseType: Types.EProductGroupReleaseType, sellingChannel?: Types.ESellingChannel | null, session?: number | null, startedAt: string, status: Types.EMarketStatus, isSoldOut: boolean, purchaseOrderType?: Types.EPurchaseOrderType | null, etcSellingChannel?: string | null, brand: { __typename?: 'BrandGraphqlType', id: number, name: string }, events?: Array<{ __typename?: 'MarketEventGraphqlType', comment?: string | null, count?: number | null, id: number, isExtraDeliveryCharged: boolean, isNotationRequired: boolean, deletable: boolean, editable: boolean, shippingBearer?: Types.EShippingBearer | null, shippingCost?: number | null, type: Types.EMarketEventType, products: Array<{ __typename?: 'MarketEventProductGraphqlType', count: number, customerBearingCost?: number | null, id: number, inhouseBuyPrice?: number | null, isCustomerBearing?: boolean | null, isFreeProvided: boolean, isPrepayment?: boolean | null, isSellerBearing?: boolean | null, isWiredBearing?: boolean | null, name: string, sellerBearingCost?: number | null, wiredBearingCost?: number | null, productId?: number | null, items?: Array<{ __typename?: 'ItemGraphqlType', id: number, name: string }> | null }> }> | null, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string }, productGroups: Array<{ __typename?: 'ProductGroupGraphqlType', id: number, name: string, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } }>, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string, kemiUserId?: string | null } | null, sellerSettlementInfo?: { __typename?: 'SellerSettlementInfoGraphqlType', id: number } | null } } };

export type AdminMarketQueryVariables = Types.Exact<{
  marketId: Types.Scalars['Int']['input'];
}>;


export type AdminMarketQuery = { __typename?: 'Query', adminMarket: { __typename?: 'MarketGraphqlType', additionalFee?: number | null, comment?: string | null, deliveryCost?: number | null, deliveryFeeType: Types.EProductGroupDeliveryFeeType, startedAt: string, endedAt?: string | null, expectedSales?: number | null, expectedSettlementAt?: string | null, freeDeliveryConditionFee?: number | null, id: number, isRegionFee: boolean, isSellerAssigned: boolean, jejuIslandFee?: number | null, name: string, releaseTime?: string | null, releaseType: Types.EProductGroupReleaseType, sellingChannel?: Types.ESellingChannel | null, session?: number | null, status: Types.EMarketStatus, isSoldOut: boolean, purchaseOrderType?: Types.EPurchaseOrderType | null, etcSellingChannel?: string | null, brand: { __typename?: 'BrandGraphqlType', id: number, name: string }, events?: Array<{ __typename?: 'MarketEventGraphqlType', comment?: string | null, count?: number | null, id: number, isExtraDeliveryCharged: boolean, isNotationRequired: boolean, deletable: boolean, editable: boolean, shippingBearer?: Types.EShippingBearer | null, shippingCost?: number | null, type: Types.EMarketEventType, products: Array<{ __typename?: 'MarketEventProductGraphqlType', count: number, customerBearingCost?: number | null, id: number, inhouseBuyPrice?: number | null, isCustomerBearing?: boolean | null, isFreeProvided: boolean, isPrepayment?: boolean | null, isSellerBearing?: boolean | null, isWiredBearing?: boolean | null, name: string, sellerBearingCost?: number | null, wiredBearingCost?: number | null, productId?: number | null, items?: Array<{ __typename?: 'ItemGraphqlType', id: number, name: string }> | null }> }> | null, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string }, productGroups: Array<{ __typename?: 'ProductGroupGraphqlType', id: number, name: string, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } }>, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string, kemiUserId?: string | null } | null, sellerSettlementInfo?: { __typename?: 'SellerSettlementInfoGraphqlType', id: number } | null } };

export type AdminDeleteMarketMutationVariables = Types.Exact<{
  marketId: Types.Scalars['Int']['input'];
}>;


export type AdminDeleteMarketMutation = { __typename?: 'Mutation', adminDeleteMarket: { __typename?: 'AdminDeleteMarketOutputGraphqlType', market: { __typename?: 'MarketGraphqlType', id: number } } };

export type AdminPatchMarketMutationVariables = Types.Exact<{
  patchMarketInput: Types.PatchMarketInputGraphqlType;
}>;


export type AdminPatchMarketMutation = { __typename?: 'Mutation', adminPatchMarket: { __typename?: 'MarketOutputGraphqlType', market: { __typename?: 'MarketGraphqlType', id: number, endedAt?: string | null, expectedSettlementAt?: string | null, startedAt: string, status: Types.EMarketStatus } } };

export type AdminMarketPreviewQueryVariables = Types.Exact<{
  marketId: Types.Scalars['Int']['input'];
}>;


export type AdminMarketPreviewQuery = { __typename?: 'Query', adminMarket: { __typename?: 'MarketGraphqlType', id: number, name: string, status: Types.EMarketStatus, isSoldOut: boolean, createdAt: string, isSellerAssigned: boolean, sellingChannel?: Types.ESellingChannel | null, startedAt: string, endedAt?: string | null, expectedSettlementAt?: string | null, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string }, sellerSettlementInfo?: { __typename?: 'SellerSettlementInfoGraphqlType', id: number, type: Types.ESellerSettlementType } | null, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string, grade?: number | null, links: Array<{ __typename?: 'SellerLinkGraphqlType', id: number, isDefault: boolean, url: string }> } | null, vendor: { __typename?: 'VendorGraphqlType', id: number, name: string }, brand: { __typename?: 'BrandGraphqlType', id: number, name: string }, productGroups: Array<{ __typename?: 'ProductGroupGraphqlType', id: number, name: string }>, checklists?: Array<{ __typename?: 'MarketChecklistGraphqlType', comment?: string | null, id: number, type: Types.EMarketChecklistType, checklistManagers?: Array<{ __typename?: 'MarketChecklistManagerGraphqlType', id: number, createdAt: string, marketChecklistId: number, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } }> | null }> | null } };

export type AdminUpdateMarketChecklistMutationVariables = Types.Exact<{
  updateMarketChecklistInput: Types.UpdateMarketChecklistInputGraphqlType;
}>;


export type AdminUpdateMarketChecklistMutation = { __typename?: 'Mutation', adminUpdateMarketChecklist: { __typename?: 'MarketChecklistOutputGraphqlType', checklist: { __typename?: 'MarketChecklistGraphqlType', comment?: string | null, createdAt: string, id: number, marketId: number, type: Types.EMarketChecklistType, updatedAt: string, checklistManagers?: Array<{ __typename?: 'MarketChecklistManagerGraphqlType', id: number, marketChecklistId: number, updatedAt: string, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } }> | null } } };

export type AdminUpsertMarketChecklistMutationVariables = Types.Exact<{
  upsertMarketChecklistInput: Types.UpsertMarketChecklistInputGraphqlType;
}>;


export type AdminUpsertMarketChecklistMutation = { __typename?: 'Mutation', adminUpsertMarketChecklist: { __typename?: 'MarketChecklistOutputGraphqlType', checklist: { __typename?: 'MarketChecklistGraphqlType', comment?: string | null, createdAt: string, id: number, marketId: number, type: Types.EMarketChecklistType, updatedAt: string, checklistManagers?: Array<{ __typename?: 'MarketChecklistManagerGraphqlType', id: number, marketChecklistId: number, updatedAt: string, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } }> | null } } };

export type AdminDeleteMarketChecklistManagerMutationVariables = Types.Exact<{
  adminDeleteMarketChecklistManagerId: Types.Scalars['Int']['input'];
}>;


export type AdminDeleteMarketChecklistManagerMutation = { __typename?: 'Mutation', adminDeleteMarketChecklistManager: { __typename?: 'MarketChecklistManagerOutputGraphqlType', checklistManager: { __typename?: 'MarketChecklistManagerGraphqlType', id: number, marketChecklistId: number, updatedAt: string, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string } } } };

export type AdminCreateKemistProductFromMarketMutationVariables = Types.Exact<{
  marketId: Types.Scalars['Int']['input'];
}>;


export type AdminCreateKemistProductFromMarketMutation = { __typename?: 'Mutation', adminCreateKemistProductFromMarket: { __typename?: 'AdminCreateKemistProductFromMarketOutputGraphqlType', productId?: string | null } };

export type AdminKemistProductsQueryVariables = Types.Exact<{
  marketId: Types.Scalars['Int']['input'];
}>;


export type AdminKemistProductsQuery = { __typename?: 'Query', adminKemistProducts: { __typename?: 'AdminKemistProductsOutputGraphqlType', products: Array<{ __typename?: 'KemistProductGraphqlType', id: string, title: string }> } };


export const CreateMarketDocument = gql`
    mutation CreateMarket($createMarketInput: CreateMarketInputGraphqlType!) {
  adminCreateMarket(createMarketInput: $createMarketInput) {
    market {
      id
      name
    }
  }
}
    `;
export type CreateMarketMutationFn = Apollo.MutationFunction<CreateMarketMutation, CreateMarketMutationVariables>;

/**
 * __useCreateMarketMutation__
 *
 * To run a mutation, you first call `useCreateMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketMutation, { data, loading, error }] = useCreateMarketMutation({
 *   variables: {
 *      createMarketInput: // value for 'createMarketInput'
 *   },
 * });
 */
export function useCreateMarketMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketMutation, CreateMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketMutation, CreateMarketMutationVariables>(CreateMarketDocument, options);
      }
export type CreateMarketMutationHookResult = ReturnType<typeof useCreateMarketMutation>;
export type CreateMarketMutationResult = Apollo.MutationResult<CreateMarketMutation>;
export type CreateMarketMutationOptions = Apollo.BaseMutationOptions<CreateMarketMutation, CreateMarketMutationVariables>;
export const AdminGetMarketsSessionDocument = gql`
    query AdminGetMarketsSession($filter: MarketPageQueryFilter) {
  adminMarkets(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useAdminGetMarketsSessionQuery__
 *
 * To run a query within a React component, call `useAdminGetMarketsSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMarketsSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMarketsSessionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminGetMarketsSessionQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMarketsSessionQuery, AdminGetMarketsSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMarketsSessionQuery, AdminGetMarketsSessionQueryVariables>(AdminGetMarketsSessionDocument, options);
      }
export function useAdminGetMarketsSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMarketsSessionQuery, AdminGetMarketsSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMarketsSessionQuery, AdminGetMarketsSessionQueryVariables>(AdminGetMarketsSessionDocument, options);
        }
export type AdminGetMarketsSessionQueryHookResult = ReturnType<typeof useAdminGetMarketsSessionQuery>;
export type AdminGetMarketsSessionLazyQueryHookResult = ReturnType<typeof useAdminGetMarketsSessionLazyQuery>;
export type AdminGetMarketsSessionQueryResult = Apollo.QueryResult<AdminGetMarketsSessionQuery, AdminGetMarketsSessionQueryVariables>;
export const UpdateMarketDocument = gql`
    mutation UpdateMarket($updateMarketInput: UpdateMarketInputGraphqlType!) {
  adminUpdateMarket(updateMarketInput: $updateMarketInput) {
    market {
      additionalFee
      brand {
        id
        name
      }
      comment
      deliveryCost
      deliveryFeeType
      endedAt
      events {
        comment
        count
        id
        isExtraDeliveryCharged
        isNotationRequired
        deletable
        editable
        products {
          count
          customerBearingCost
          id
          inhouseBuyPrice
          isCustomerBearing
          isFreeProvided
          isPrepayment
          isSellerBearing
          isWiredBearing
          name
          sellerBearingCost
          wiredBearingCost
          productId
          items {
            id
            name
          }
        }
        shippingBearer
        shippingCost
        type
      }
      expectedSales
      expectedSettlementAt
      freeDeliveryConditionFee
      id
      isRegionFee
      isSellerAssigned
      jejuIslandFee
      manager {
        id
        name
      }
      name
      productGroups {
        id
        name
        manager {
          id
          name
        }
      }
      releaseTime
      releaseType
      seller {
        id
        name
        kemiUserId
      }
      sellerSettlementInfo {
        id
      }
      sellingChannel
      session
      startedAt
      status
      isSoldOut
      purchaseOrderType
      etcSellingChannel
    }
  }
}
    `;
export type UpdateMarketMutationFn = Apollo.MutationFunction<UpdateMarketMutation, UpdateMarketMutationVariables>;

/**
 * __useUpdateMarketMutation__
 *
 * To run a mutation, you first call `useUpdateMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketMutation, { data, loading, error }] = useUpdateMarketMutation({
 *   variables: {
 *      updateMarketInput: // value for 'updateMarketInput'
 *   },
 * });
 */
export function useUpdateMarketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketMutation, UpdateMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketMutation, UpdateMarketMutationVariables>(UpdateMarketDocument, options);
      }
export type UpdateMarketMutationHookResult = ReturnType<typeof useUpdateMarketMutation>;
export type UpdateMarketMutationResult = Apollo.MutationResult<UpdateMarketMutation>;
export type UpdateMarketMutationOptions = Apollo.BaseMutationOptions<UpdateMarketMutation, UpdateMarketMutationVariables>;
export const AdminMarketDocument = gql`
    query AdminMarket($marketId: Int!) {
  adminMarket(marketId: $marketId) {
    additionalFee
    brand {
      id
      name
    }
    comment
    deliveryCost
    deliveryFeeType
    startedAt
    endedAt
    events {
      comment
      count
      id
      isExtraDeliveryCharged
      isNotationRequired
      deletable
      editable
      products {
        count
        customerBearingCost
        id
        inhouseBuyPrice
        isCustomerBearing
        isFreeProvided
        isPrepayment
        isSellerBearing
        isWiredBearing
        name
        sellerBearingCost
        wiredBearingCost
        productId
        items {
          id
          name
        }
      }
      shippingBearer
      shippingCost
      type
    }
    expectedSales
    expectedSettlementAt
    freeDeliveryConditionFee
    id
    isRegionFee
    isSellerAssigned
    jejuIslandFee
    manager {
      id
      name
    }
    name
    productGroups {
      id
      name
      manager {
        id
        name
      }
    }
    releaseTime
    releaseType
    seller {
      id
      name
      kemiUserId
    }
    sellerSettlementInfo {
      id
    }
    sellingChannel
    session
    startedAt
    status
    isSoldOut
    purchaseOrderType
    etcSellingChannel
  }
}
    `;

/**
 * __useAdminMarketQuery__
 *
 * To run a query within a React component, call `useAdminMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMarketQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminMarketQuery(baseOptions: Apollo.QueryHookOptions<AdminMarketQuery, AdminMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMarketQuery, AdminMarketQueryVariables>(AdminMarketDocument, options);
      }
export function useAdminMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMarketQuery, AdminMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMarketQuery, AdminMarketQueryVariables>(AdminMarketDocument, options);
        }
export type AdminMarketQueryHookResult = ReturnType<typeof useAdminMarketQuery>;
export type AdminMarketLazyQueryHookResult = ReturnType<typeof useAdminMarketLazyQuery>;
export type AdminMarketQueryResult = Apollo.QueryResult<AdminMarketQuery, AdminMarketQueryVariables>;
export const AdminDeleteMarketDocument = gql`
    mutation AdminDeleteMarket($marketId: Int!) {
  adminDeleteMarket(marketId: $marketId) {
    market {
      id
    }
  }
}
    `;
export type AdminDeleteMarketMutationFn = Apollo.MutationFunction<AdminDeleteMarketMutation, AdminDeleteMarketMutationVariables>;

/**
 * __useAdminDeleteMarketMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMarketMutation, { data, loading, error }] = useAdminDeleteMarketMutation({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminDeleteMarketMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMarketMutation, AdminDeleteMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMarketMutation, AdminDeleteMarketMutationVariables>(AdminDeleteMarketDocument, options);
      }
export type AdminDeleteMarketMutationHookResult = ReturnType<typeof useAdminDeleteMarketMutation>;
export type AdminDeleteMarketMutationResult = Apollo.MutationResult<AdminDeleteMarketMutation>;
export type AdminDeleteMarketMutationOptions = Apollo.BaseMutationOptions<AdminDeleteMarketMutation, AdminDeleteMarketMutationVariables>;
export const AdminPatchMarketDocument = gql`
    mutation AdminPatchMarket($patchMarketInput: PatchMarketInputGraphqlType!) {
  adminPatchMarket(patchMarketInput: $patchMarketInput) {
    market {
      id
      endedAt
      expectedSettlementAt
      startedAt
      status
    }
  }
}
    `;
export type AdminPatchMarketMutationFn = Apollo.MutationFunction<AdminPatchMarketMutation, AdminPatchMarketMutationVariables>;

/**
 * __useAdminPatchMarketMutation__
 *
 * To run a mutation, you first call `useAdminPatchMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPatchMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPatchMarketMutation, { data, loading, error }] = useAdminPatchMarketMutation({
 *   variables: {
 *      patchMarketInput: // value for 'patchMarketInput'
 *   },
 * });
 */
export function useAdminPatchMarketMutation(baseOptions?: Apollo.MutationHookOptions<AdminPatchMarketMutation, AdminPatchMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPatchMarketMutation, AdminPatchMarketMutationVariables>(AdminPatchMarketDocument, options);
      }
export type AdminPatchMarketMutationHookResult = ReturnType<typeof useAdminPatchMarketMutation>;
export type AdminPatchMarketMutationResult = Apollo.MutationResult<AdminPatchMarketMutation>;
export type AdminPatchMarketMutationOptions = Apollo.BaseMutationOptions<AdminPatchMarketMutation, AdminPatchMarketMutationVariables>;
export const AdminMarketPreviewDocument = gql`
    query AdminMarketPreview($marketId: Int!) {
  adminMarket(marketId: $marketId) {
    id
    name
    status
    isSoldOut
    createdAt
    isSellerAssigned
    manager {
      id
      name
    }
    sellerSettlementInfo {
      id
      type
    }
    sellingChannel
    seller {
      id
      name
      grade
      links {
        id
        isDefault
        url
      }
    }
    startedAt
    endedAt
    vendor {
      id
      name
    }
    brand {
      id
      name
    }
    productGroups {
      id
      name
    }
    expectedSettlementAt
    checklists {
      checklistManagers {
        id
        createdAt
        marketChecklistId
        manager {
          id
          name
        }
      }
      comment
      id
      type
    }
  }
}
    `;

/**
 * __useAdminMarketPreviewQuery__
 *
 * To run a query within a React component, call `useAdminMarketPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMarketPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMarketPreviewQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminMarketPreviewQuery(baseOptions: Apollo.QueryHookOptions<AdminMarketPreviewQuery, AdminMarketPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMarketPreviewQuery, AdminMarketPreviewQueryVariables>(AdminMarketPreviewDocument, options);
      }
export function useAdminMarketPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMarketPreviewQuery, AdminMarketPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMarketPreviewQuery, AdminMarketPreviewQueryVariables>(AdminMarketPreviewDocument, options);
        }
export type AdminMarketPreviewQueryHookResult = ReturnType<typeof useAdminMarketPreviewQuery>;
export type AdminMarketPreviewLazyQueryHookResult = ReturnType<typeof useAdminMarketPreviewLazyQuery>;
export type AdminMarketPreviewQueryResult = Apollo.QueryResult<AdminMarketPreviewQuery, AdminMarketPreviewQueryVariables>;
export const AdminUpdateMarketChecklistDocument = gql`
    mutation AdminUpdateMarketChecklist($updateMarketChecklistInput: UpdateMarketChecklistInputGraphqlType!) {
  adminUpdateMarketChecklist(
    updateMarketChecklistInput: $updateMarketChecklistInput
  ) {
    checklist {
      checklistManagers {
        id
        manager {
          id
          name
        }
        marketChecklistId
        updatedAt
      }
      comment
      createdAt
      id
      marketId
      type
      updatedAt
    }
  }
}
    `;
export type AdminUpdateMarketChecklistMutationFn = Apollo.MutationFunction<AdminUpdateMarketChecklistMutation, AdminUpdateMarketChecklistMutationVariables>;

/**
 * __useAdminUpdateMarketChecklistMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMarketChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMarketChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMarketChecklistMutation, { data, loading, error }] = useAdminUpdateMarketChecklistMutation({
 *   variables: {
 *      updateMarketChecklistInput: // value for 'updateMarketChecklistInput'
 *   },
 * });
 */
export function useAdminUpdateMarketChecklistMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMarketChecklistMutation, AdminUpdateMarketChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMarketChecklistMutation, AdminUpdateMarketChecklistMutationVariables>(AdminUpdateMarketChecklistDocument, options);
      }
export type AdminUpdateMarketChecklistMutationHookResult = ReturnType<typeof useAdminUpdateMarketChecklistMutation>;
export type AdminUpdateMarketChecklistMutationResult = Apollo.MutationResult<AdminUpdateMarketChecklistMutation>;
export type AdminUpdateMarketChecklistMutationOptions = Apollo.BaseMutationOptions<AdminUpdateMarketChecklistMutation, AdminUpdateMarketChecklistMutationVariables>;
export const AdminUpsertMarketChecklistDocument = gql`
    mutation AdminUpsertMarketChecklist($upsertMarketChecklistInput: UpsertMarketChecklistInputGraphqlType!) {
  adminUpsertMarketChecklist(
    upsertMarketChecklistInput: $upsertMarketChecklistInput
  ) {
    checklist {
      checklistManagers {
        id
        manager {
          id
          name
        }
        marketChecklistId
        updatedAt
      }
      comment
      createdAt
      id
      marketId
      type
      updatedAt
    }
  }
}
    `;
export type AdminUpsertMarketChecklistMutationFn = Apollo.MutationFunction<AdminUpsertMarketChecklistMutation, AdminUpsertMarketChecklistMutationVariables>;

/**
 * __useAdminUpsertMarketChecklistMutation__
 *
 * To run a mutation, you first call `useAdminUpsertMarketChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertMarketChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertMarketChecklistMutation, { data, loading, error }] = useAdminUpsertMarketChecklistMutation({
 *   variables: {
 *      upsertMarketChecklistInput: // value for 'upsertMarketChecklistInput'
 *   },
 * });
 */
export function useAdminUpsertMarketChecklistMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpsertMarketChecklistMutation, AdminUpsertMarketChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpsertMarketChecklistMutation, AdminUpsertMarketChecklistMutationVariables>(AdminUpsertMarketChecklistDocument, options);
      }
export type AdminUpsertMarketChecklistMutationHookResult = ReturnType<typeof useAdminUpsertMarketChecklistMutation>;
export type AdminUpsertMarketChecklistMutationResult = Apollo.MutationResult<AdminUpsertMarketChecklistMutation>;
export type AdminUpsertMarketChecklistMutationOptions = Apollo.BaseMutationOptions<AdminUpsertMarketChecklistMutation, AdminUpsertMarketChecklistMutationVariables>;
export const AdminDeleteMarketChecklistManagerDocument = gql`
    mutation AdminDeleteMarketChecklistManager($adminDeleteMarketChecklistManagerId: Int!) {
  adminDeleteMarketChecklistManager(id: $adminDeleteMarketChecklistManagerId) {
    checklistManager {
      id
      manager {
        id
        name
      }
      marketChecklistId
      updatedAt
    }
  }
}
    `;
export type AdminDeleteMarketChecklistManagerMutationFn = Apollo.MutationFunction<AdminDeleteMarketChecklistManagerMutation, AdminDeleteMarketChecklistManagerMutationVariables>;

/**
 * __useAdminDeleteMarketChecklistManagerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMarketChecklistManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMarketChecklistManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMarketChecklistManagerMutation, { data, loading, error }] = useAdminDeleteMarketChecklistManagerMutation({
 *   variables: {
 *      adminDeleteMarketChecklistManagerId: // value for 'adminDeleteMarketChecklistManagerId'
 *   },
 * });
 */
export function useAdminDeleteMarketChecklistManagerMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMarketChecklistManagerMutation, AdminDeleteMarketChecklistManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMarketChecklistManagerMutation, AdminDeleteMarketChecklistManagerMutationVariables>(AdminDeleteMarketChecklistManagerDocument, options);
      }
export type AdminDeleteMarketChecklistManagerMutationHookResult = ReturnType<typeof useAdminDeleteMarketChecklistManagerMutation>;
export type AdminDeleteMarketChecklistManagerMutationResult = Apollo.MutationResult<AdminDeleteMarketChecklistManagerMutation>;
export type AdminDeleteMarketChecklistManagerMutationOptions = Apollo.BaseMutationOptions<AdminDeleteMarketChecklistManagerMutation, AdminDeleteMarketChecklistManagerMutationVariables>;
export const AdminCreateKemistProductFromMarketDocument = gql`
    mutation AdminCreateKemistProductFromMarket($marketId: Int!) {
  adminCreateKemistProductFromMarket(marketId: $marketId) {
    productId
  }
}
    `;
export type AdminCreateKemistProductFromMarketMutationFn = Apollo.MutationFunction<AdminCreateKemistProductFromMarketMutation, AdminCreateKemistProductFromMarketMutationVariables>;

/**
 * __useAdminCreateKemistProductFromMarketMutation__
 *
 * To run a mutation, you first call `useAdminCreateKemistProductFromMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateKemistProductFromMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateKemistProductFromMarketMutation, { data, loading, error }] = useAdminCreateKemistProductFromMarketMutation({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminCreateKemistProductFromMarketMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateKemistProductFromMarketMutation, AdminCreateKemistProductFromMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateKemistProductFromMarketMutation, AdminCreateKemistProductFromMarketMutationVariables>(AdminCreateKemistProductFromMarketDocument, options);
      }
export type AdminCreateKemistProductFromMarketMutationHookResult = ReturnType<typeof useAdminCreateKemistProductFromMarketMutation>;
export type AdminCreateKemistProductFromMarketMutationResult = Apollo.MutationResult<AdminCreateKemistProductFromMarketMutation>;
export type AdminCreateKemistProductFromMarketMutationOptions = Apollo.BaseMutationOptions<AdminCreateKemistProductFromMarketMutation, AdminCreateKemistProductFromMarketMutationVariables>;
export const AdminKemistProductsDocument = gql`
    query AdminKemistProducts($marketId: Int!) {
  adminKemistProducts(marketId: $marketId) {
    products {
      id
      title
    }
  }
}
    `;

/**
 * __useAdminKemistProductsQuery__
 *
 * To run a query within a React component, call `useAdminKemistProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminKemistProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminKemistProductsQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminKemistProductsQuery(baseOptions: Apollo.QueryHookOptions<AdminKemistProductsQuery, AdminKemistProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminKemistProductsQuery, AdminKemistProductsQueryVariables>(AdminKemistProductsDocument, options);
      }
export function useAdminKemistProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminKemistProductsQuery, AdminKemistProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminKemistProductsQuery, AdminKemistProductsQueryVariables>(AdminKemistProductsDocument, options);
        }
export type AdminKemistProductsQueryHookResult = ReturnType<typeof useAdminKemistProductsQuery>;
export type AdminKemistProductsLazyQueryHookResult = ReturnType<typeof useAdminKemistProductsLazyQuery>;
export type AdminKemistProductsQueryResult = Apollo.QueryResult<AdminKemistProductsQuery, AdminKemistProductsQueryVariables>;